module.exports = __webpack_public_path__ + "static/media/stationaryModal.da25d33e.jpg";